/**
 * HandRaisedIcon — heroicons outline "hand-raised" used across the agentic-hub
 * to mark "this needs your attention" affordances (pending-question badges in
 * SearchTabs, EmailSelector header chip, agent-question cards).
 *
 * Numeo DS notes: stroke matches the badge's text color via `currentColor`. The
 * default stroke weight is 1.8 to read at the 10-12px badge sizes we use most;
 * pass `strokeWidth` to override (e.g. 2.5 for stand-alone usage).
 */

export interface HandRaisedIconProps {
    className?: string
    strokeWidth?: number
}

export const HandRaisedIcon = ({ className = 'h-2.5 w-2.5 shrink-0', strokeWidth = 1.8 }: HandRaisedIconProps) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={strokeWidth}>
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M10.05 4.575a1.575 1.575 0 10-3.15 0v3m3.15-3v-1.5a1.575 1.575 0 013.15 0v1.5m-3.15 0l.075 5.925m3.075.75V4.575m0 0a1.575 1.575 0 013.15 0V15M6.9 7.575a1.575 1.575 0 10-3.15 0v8.175a6.75 6.75 0 006.75 6.75h2.018a5.25 5.25 0 003.712-1.538l1.732-1.732a5.25 5.25 0 001.538-3.712l.003-2.024a.668.668 0 01.198-.471 1.575 1.575 0 10-2.228-2.228 3.818 3.818 0 00-1.12 2.687M6.9 7.575V12m6.27 4.318A4.49 4.49 0 0116.35 15m.002 0h-.002"
        />
    </svg>
)
